/**
 * Boolean Input Component for dev-tools
 * Part of Phase 3 refactoring - Component Decomposition (UI Components)
 */
import React from "react";

import { Checkbox, FormControlLabel } from "@mui/material";

import { FieldSchema } from "../../types";

interface BooleanInputProps {
  field: FieldSchema;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  touched?: boolean;
}

export const BooleanInput: React.FC<BooleanInputProps> = ({
  field,
  value,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={Boolean(value)}
          onChange={handleChange}
          name={field.name}
          color="primary"
          size="small"
        />
      }
      label={field.name}
      sx={{ mt: 0.5, mb: 0.5 }}
    />
  );
};
